import { lazy } from 'react';

let components = {
  '@/components/social/SinglePostEmbed': () => import(`@/components/social/SinglePostEmbed`),
  '@/components/registration/BusinessUpgrade': () =>
    import(`@/components/registration/BusinessUpgrade`),
  '@/components/user/profile/Edit': () => import(`@/components/user/profile/Edit`),
  '@/components/user/profile/AddPosition': () => import(`@/components/user/profile/AddPosition`),
  '@/components/user/profile/add-position/ChooseType': () =>
    import(`@/components/user/profile/add-position/ChooseType`),
  '@/components/management/layout/Business': () =>
    import(`@/components/management/layout/Business`),
  '@/components/management/home/IndexBusiness': () =>
    import(`@/components/management/home/IndexBusiness`),
  '@/components/management/home/Business': () => import(`@/components/management/home/Business`),
  '@/components/user/profile/add-position/formal': () =>
    import(`@/components/user/profile/add-position/formal`),
  '@/components/user/profile/add-position/formal/Details': () =>
    import(`@/components/user/profile/add-position/formal/Details`),
  '@/components/user/profile/add-position/Informal': () =>
    import(`@/components/user/profile/add-position/Informal`),
  '@/components/user/Profile': () => import(`@/components/user/Profile`),
  '@/components/user/profile/Volunteerism': () => import(`@/components/user/profile/Volunteerism`),
  '@/components/user/profile/Testimonials': () => import(`@/components/user/profile/Testimonials`),
  '@/components/user/profile/Stories': () => import(`@/components/user/profile/Stories`),
  '@/components/user/profile/Submissions': () => import(`@/components/user/profile/Submissions`),
  '@/components/business/Profile': () => import(`@/components/business/Profile`),
  '@/components/business/EmployeeVolunteerism': () =>
    import(`@/components/business/EmployeeVolunteerism`),
  '@/components/business/SupportedOrganizations': () =>
    import(`@/components/business/SupportedOrganizations`),
  '@/components/business/Events': () => import(`@/components/business/Events`),
  '@/components/business/Positions': () => import(`@/components/business/Positions`),
  '@/components/business/Testimonials': () => import(`@/components/business/Testimonials`),
  '@/components/business/ViewTestimonial': () => import(`@/components/business/ViewTestimonial`),
  '@/components/business/Pledge': () => import(`@/components/business/Pledge`),
  '@/components/business/Locations': () => import(`@/components/business/Locations`),
  '@/components/organization/Profile': () => import(`@/components/organization/Profile`),
  '@/components/organization/EmployeeVolunteerism': () =>
    import(`@/components/organization/EmployeeVolunteerism`),
  '@/components/organization/Relationships': () =>
    import(`@/components/organization/Relationships`),
  '@/components/organization/Events': () => import(`@/components/organization/Events`),
  '@/components/organization/Positions': () => import(`@/components/organization/Positions`),
  '@/components/organization/Locations': () => import(`@/components/organization/Locations`),
  '@/components/opportunities/View': () => import(`@/components/opportunities/View`),
  '@/components/events/Profile': () => import(`@/components/events/Profile`),
  '@/components/opportunities/browse': () => import(`@/components/opportunities/browse`),
  '@/components/community/Events': () => import(`@/components/community/Events`),
  '@/components/community/Organizations': () => import(`@/components/community/Organizations`),
  '@/components/community/Businesses': () => import(`@/components/community/Businesses`),
  '@/components/business/LeaveInformalTestimonial': () =>
    import(`@/components/business/LeaveInformalTestimonial`),
  '@/components/social/SinglePost': () => import(`@/components/social/SinglePost`),
  '@/components/social/PrintPost': () => import(`@/components/social/PrintPost`),
  '@/components/LogoutOfProxy': () => import(`@/components/LogoutOfProxy`),
  '@/components/forms/common/Context': () => import(`@/components/forms/common/Context`),
  '@/components/forms/common/View': () => import(`@/components/forms/common/View`),
  '@/components/forms/common/Thanks': () => import(`@/components/forms/common/Thanks`),
  '@/components/user/UnknownCity': () => import(`@/components/user/UnknownCity`),
  '@/components/user/CanadaUSOnly': () => import(`@/components/user/CanadaUSOnly`),
  '@/components/user/VerifySsoEmail': () => import(`@/components/user/VerifySsoEmail`),
  '@/components/user/WelcomeWizard': () => import(`@/components/user/WelcomeWizard`),
  '@/components/registration/Business': () => import(`@/components/registration/Business`),
  '@/components/registration/BusinessGoal': () => import(`@/components/registration/BusinessGoal`),
  '@/components/registration/BusinessPledge': () =>
    import(`@/components/registration/BusinessPledge`),
  '@/components/management/account/BillingInfo': () =>
    import(`@/components/management/account/BillingInfo`),
  '@/components/management/account/ThankYou': () =>
    import(`@/components/management/account/ThankYou`),
  '@/components/registration/Organization': () => import(`@/components/registration/Organization`),
  '@/components/registration/OrganizationGoal': () =>
    import(`@/components/registration/OrganizationGoal`),
  '@/components/user/ViewInvite': () => import(`@/components/user/ViewInvite`),
  '@/components/management/forms/submissions/PrintView': () =>
    import(`@/components/management/forms/submissions/PrintView`),
  '@/components/user/Welcome': () => import(`@/components/user/Welcome`),
  '@/components/user/AcceptInvite': () => import(`@/components/user/AcceptInvite`),
  '@/components/user/Dashboard': () => import(`@/components/user/Dashboard`),
  '@/components/social/EditPost': () => import(`@/components/social/EditPost`),
  '@/components/user/Settings': () => import(`@/components/user/Settings`),
  '@/components/user/log-time': () => import(`@/components/user/log-time`),
  '@/components/user/log-time/PositionPicker': () =>
    import(`@/components/user/log-time/PositionPicker`),
  '@/components/user/log-time/Thanks': () => import(`@/components/user/log-time/Thanks`),
  '@/components/user/log-time/ShiftPicker': () => import(`@/components/user/log-time/ShiftPicker`),
  '@/components/user/log-time/DateLogger': () => import(`@/components/user/log-time/DateLogger`),
  '@/components/user/log-time/ShiftLogger': () => import(`@/components/user/log-time/ShiftLogger`),
  '@/components/user/messaging/Inbox': () => import(`@/components/user/messaging/Inbox`),
  '@/components/user/messaging/thread': () => import(`@/components/user/messaging/thread`),
  '@/components/opportunities/Apply': () => import(`@/components/opportunities/Apply`),
  '@/components/opportunities/ApplyThanks': () => import(`@/components/opportunities/ApplyThanks`),
  '@/components/opportunities/UpdateAttendance': () =>
    import(`@/components/opportunities/UpdateAttendance`),
  '@/components/forms/user/Submission': () => import(`@/components/forms/user/Submission`),
  '@/components/business/team/index': () => import(`@/components/business/team/index`),
  '@/components/business/team/Coworkers': () => import(`@/components/business/team/Coworkers`),
  '@/components/business/team/Feed': () => import(`@/components/business/team/Feed`),
  '@/components/business/team/Dashboard': () => import(`@/components/business/team/Dashboard`),
  '@/components/staff/Dashboard': () => import(`@/components/staff/Dashboard`),
  '@/components/staff/users': () => import(`@/components/staff/users`),
  '@/components/staff/orgList': () => import(`@/components/staff/orgList`),
  '@/components/staff/MessageUsers': () => import(`@/components/staff/MessageUsers`),
  '@/components/staff/mergeOrgs': () => import(`@/components/staff/mergeOrgs`),
  '@/components/staff/InviteBusiness': () => import(`@/components/staff/InviteBusiness`),
  '@/components/staff/InviteOrganization': () => import(`@/components/staff/InviteOrganization`),
  '@/components/staff/geoReport': () => import(`@/components/staff/geoReport`),
  '@/components/staff/trendPage/trendPage': () => import(`@/components/staff/trendPage/trendPage`),
  '@/components/staff/PushBroadcast': () => import(`@/components/staff/PushBroadcast`),
  '@/components/staff/ShortUrl': () => import(`@/components/staff/ShortUrl`),
  '@/components/staff/CustomReports': () => import(`@/components/staff/CustomReports`),
  '@/components/staff/reports/RegenReport': () => import(`@/components/staff/reports/RegenReport`),
  '@/components/staff/CityAdd': () => import(`@/components/staff/CityAdd`),
  '@/components/staff/CityEdit': () => import(`@/components/staff/CityEdit`),
  '@/components/staff/CityWrapper': () => import(`@/components/staff/CityWrapper`),
  '@/components/staff/CityRadius': () => import(`@/components/staff/CityRadius`),
  '@/components/staff/BusinessWrapper': () => import(`@/components/staff/BusinessWrapper`),
  '@/components/staff/BusinessDetails': () => import(`@/components/staff/BusinessDetails`),
  '@/components/staff/PaymentMethod': () => import(`@/components/staff/PaymentMethod`),
  '@/components/staff/BusinessStats': () => import(`@/components/staff/BusinessStats`),
  '@/components/staff/OrganizationWrapper': () => import(`@/components/staff/OrganizationWrapper`),
  '@/components/staff/OrganizationDetails': () => import(`@/components/staff/OrganizationDetails`),
  '@/components/staff/reports/List': () => import(`@/components/staff/reports/List`),
  '@/components/staff/reports/Editor': () => import(`@/components/staff/reports/Editor`),
  '@/components/staff/UserDetails': () => import(`@/components/staff/UserDetails`),
  '@/components/staff/media': () => import(`@/components/staff/media`),
  '@/components/staff/media/List': () => import(`@/components/staff/media/List`),
  '@/components/staff/media/Create': () => import(`@/components/staff/media/Create`),
  '@/components/staff/media/Summary': () => import(`@/components/staff/media/Summary`),
  '@/components/staff/media/Feed': () => import(`@/components/staff/media/Feed`),
  '@/components/management/account': () => import(`@/components/management/account`),
  '@/components/management/onboarding/business': () =>
    import(`@/components/management/onboarding/business`),
  '@/components/management/onboarding/business/StepOverview': () =>
    import(`@/components/management/onboarding/business/StepOverview`),
  '@/components/management/onboarding/business/stepset/PageTemplate': () =>
    import(`@/components/management/onboarding/business/stepset/PageTemplate`),
  '@/components/management/onboarding/business/steps/Pledge': () =>
    import(`@/components/management/onboarding/business/steps/Pledge`),
  '@/components/management/onboarding/business/steps/Logo': () =>
    import(`@/components/management/onboarding/business/steps/Logo`),
  '@/components/management/onboarding/business/steps/Causes': () =>
    import(`@/components/management/onboarding/business/steps/Causes`),
  '@/components/management/onboarding/business/steps/About': () =>
    import(`@/components/management/onboarding/business/steps/About`),
  '@/components/management/onboarding/business/steps/AboutCombined': () =>
    import(`@/components/management/onboarding/business/steps/AboutCombined`),
  '@/components/management/onboarding/business/steps/AddConnection': () =>
    import(`@/components/management/onboarding/business/steps/AddConnection`),
  '@/components/management/onboarding/business/steps/AutoPostStory': () =>
    import(`@/components/management/onboarding/business/steps/AutoPostStory`),
  '@/components/management/onboarding/business/steps/Contributions': () =>
    import(`@/components/management/onboarding/business/steps/Contributions`),
  '@/components/management/onboarding/business/steps/EmailSignatures': () =>
    import(`@/components/management/onboarding/business/steps/EmailSignatures`),
  '@/components/management/onboarding/business/steps/CareerPostings': () =>
    import(`@/components/management/onboarding/business/steps/CareerPostings`),
  '@/components/management/onboarding/business/steps/ShareProfile': () =>
    import(`@/components/management/onboarding/business/steps/ShareProfile`),
  '@/components/management/onboarding/business/steps/BusinessType': () =>
    import(`@/components/management/onboarding/business/steps/BusinessType`),
  '@/components/management/social': () => import(`@/components/management/social`),
  '@/components/management/social/Feed': () => import(`@/components/management/social/Feed`),
  '@/components/management/social/Drafts': () => import(`@/components/management/social/Drafts`),
  '@/components/management/social/Scheduled': () =>
    import(`@/components/management/social/Scheduled`),
  '@/components/management/marketing/Resources': () =>
    import(`@/components/management/marketing/Resources`),
  '@/components/management/social/ApproveContent': () =>
    import(`@/components/management/social/ApproveContent`),
  '@/components/management/opportunities': () => import(`@/components/management/opportunities`),
  '@/components/management/opportunities/List': () =>
    import(`@/components/management/opportunities/List`),
  '@/components/management/opportunities/Create': () =>
    import(`@/components/management/opportunities/Create`),
  '@/components/management/opportunities/AddBeneficiary': () =>
    import(`@/components/management/opportunities/AddBeneficiary`),
  '@/components/management/opportunities/Summary': () =>
    import(`@/components/management/opportunities/Summary`),
  '@/components/management/opportunities/Edit': () =>
    import(`@/components/management/opportunities/Edit`),
  '@/components/management/opportunities/CreateShift': () =>
    import(`@/components/management/opportunities/CreateShift`),
  '@/components/management/opportunities/ShiftSummary': () =>
    import(`@/components/management/opportunities/ShiftSummary`),
  '@/components/management/opportunities/ShiftEdit': () =>
    import(`@/components/management/opportunities/ShiftEdit`),
  '@/components/management/events/List': () => import(`@/components/management/events/List`),
  '@/components/management/events/Create': () => import(`@/components/management/events/Create`),
  '@/components/management/events/AddSupporter': () =>
    import(`@/components/management/events/AddSupporter`),
  '@/components/management/events/AddBeneficiary': () =>
    import(`@/components/management/events/AddBeneficiary`),
  '@/components/management/events/Summary': () => import(`@/components/management/events/Summary`),
  '@/components/management/events/Edit': () => import(`@/components/management/events/Edit`),
  '@/components/management/approvalqueues/ApproveApplicants': () =>
    import(`@/components/management/approvalqueues/ApproveApplicants`),
  '@/components/management/approvalqueues/ApproveOrganizationOrBusinessHours': () =>
    import(`@/components/management/approvalqueues/ApproveOrganizationOrBusinessHours`),
  '@/components/management/reports/business/Volunteerism': () =>
    import(`@/components/management/reports/business/Volunteerism`),
  '@/components/management/invites/Organizations': () =>
    import(`@/components/management/invites/Organizations`),
  '@/components/management/invites/Businesses': () =>
    import(`@/components/management/invites/Businesses`),
  '@/components/management/invites/Employees': () =>
    import(`@/components/management/invites/Employees`),
  '@/components/management/invites/Admins': () => import(`@/components/management/invites/Admins`),
  '@/components/management/invites/Members': () =>
    import(`@/components/management/invites/Members`),
  '@/components/management/employees': () => import(`@/components/management/employees`),
  '@/components/management/employees/List': () => import(`@/components/management/employees/List`),
  '@/components/management/employees/roles': () =>
    import(`@/components/management/employees/roles`),
  '@/components/management/employees/roles/List': () =>
    import(`@/components/management/employees/roles/List`),
  '@/components/management/employees/roles/Create': () =>
    import(`@/components/management/employees/roles/Create`),
  '@/components/management/employees/roles/Summary': () =>
    import(`@/components/management/employees/roles/Summary`),
  '@/components/management/employees/roles/Edit': () =>
    import(`@/components/management/employees/roles/Edit`),
  '@/components/management/employees/dashboard/BusinessTeamDashboard': () =>
    import(`@/components/management/employees/dashboard/BusinessTeamDashboard`),
  '@/components/management/approvalqueues/ApproveTeam': () =>
    import(`@/components/management/approvalqueues/ApproveTeam`),
  '@/components/management/reports/business/Team': () =>
    import(`@/components/management/reports/business/Team`),
  '@/components/management/employees/Summary': () =>
    import(`@/components/management/employees/Summary`),
  '@/components/management/members': () => import(`@/components/management/members`),
  '@/components/management/members/List': () => import(`@/components/management/members/List`),
  '@/components/management/members/dashboard/MemberDashboard': () =>
    import(`@/components/management/members/dashboard/MemberDashboard`),
  '@/components/management/relationships/business/IndexOrganizations': () =>
    import(`@/components/management/relationships/business/IndexOrganizations`),
  '@/components/management/relationships/business/Testimonials': () =>
    import(`@/components/management/relationships/business/Testimonials`),
  '@/components/management/relationships/business/Organizations': () =>
    import(`@/components/management/relationships/business/Organizations`),
  '@/components/management/relationships/business/AddOrganization': () =>
    import(`@/components/management/relationships/business/AddOrganization`),
  '@/components/management/reports/business/Community': () =>
    import(`@/components/management/reports/business/Community`),
  '@/components/management/relationships/business/organizations/Details': () =>
    import(`@/components/management/relationships/business/organizations/Details`),
  '@/components/management/relationships/business/IndexBusinesses': () =>
    import(`@/components/management/relationships/business/IndexBusinesses`),
  '@/components/management/relationships/business/businesses/Testimonials': () =>
    import(`@/components/management/relationships/business/businesses/Testimonials`),
  '@/components/management/relationships/business/businesses/Widgets': () =>
    import(`@/components/management/relationships/business/businesses/Widgets`),
  '@/components/management/relationships/business/businesses/widgets/index': () =>
    import(`@/components/management/relationships/business/businesses/widgets/index`),
  '@/components/management/relationships/business/businesses/widgets/News': () =>
    import(`@/components/management/relationships/business/businesses/widgets/News`),
  '@/components/management/relationships/business/businesses/widgets/Organizations': () =>
    import(`@/components/management/relationships/business/businesses/widgets/Organizations`),
  '@/components/management/relationships/business/businesses/widgets/Businesses': () =>
    import(`@/components/management/relationships/business/businesses/widgets/Businesses`),
  '@/components/management/relationships/business/businesses/widgets/Testimonials': () =>
    import(`@/components/management/relationships/business/businesses/widgets/Testimonials`),
  '@/components/management/relationships/business/businesses/widgets/Ticker': () =>
    import(`@/components/management/relationships/business/businesses/widgets/Ticker`),
  '@/components/management/relationships/business/businesses/News': () =>
    import(`@/components/management/relationships/business/businesses/News`),
  '@/components/management/relationships/business/businesses/List': () =>
    import(`@/components/management/relationships/business/businesses/List`),
  '@/components/management/relationships/business/AddBusiness': () =>
    import(`@/components/management/relationships/business/AddBusiness`),
  '@/components/management/reports/business/Business': () =>
    import(`@/components/management/reports/business/Business`),
  '@/components/management/profile': () => import(`@/components/management/profile`),
  '@/components/management/profile/business/Profile': () =>
    import(`@/components/management/profile/business/Profile`),
  '@/components/management/profile/Addresses': () =>
    import(`@/components/management/profile/Addresses`),
  '@/components/management/profile/BusinessGetListed': () =>
    import(`@/components/management/profile/BusinessGetListed`),
  '@/components/management/profile/business/Settings': () =>
    import(`@/components/management/profile/business/Settings`),
  '@/components/management/pages': () => import(`@/components/management/pages`),
  '@/components/management/pages/List': () => import(`@/components/management/pages/List`),
  '@/components/management/pages/Create': () => import(`@/components/management/pages/Create`),
  '@/components/management/pages/builder': () => import(`@/components/management/pages/builder`),
  '@/components/management/pages/Preview': () => import(`@/components/management/pages/Preview`),
  '@/components/management/forms': () => import(`@/components/management/forms`),
  '@/components/management/forms/forms/List': () =>
    import(`@/components/management/forms/forms/List`),
  '@/components/management/forms/forms/Create': () =>
    import(`@/components/management/forms/forms/Create`),
  '@/components/management/reports/business/Forms': () =>
    import(`@/components/management/reports/business/Forms`),
  '@/components/management/forms/submissions/List': () =>
    import(`@/components/management/forms/submissions/List`),
  '@/components/management/forms/submissions/ListCustomViews': () =>
    import(`@/components/management/forms/submissions/ListCustomViews`),
  '@/components/management/forms/submissions/ManageViews': () =>
    import(`@/components/management/forms/submissions/ManageViews`),
  '@/components/management/forms/submissions/CreateView': () =>
    import(`@/components/management/forms/submissions/CreateView`),
  '@/components/management/forms/submissions/Summary': () =>
    import(`@/components/management/forms/submissions/Summary`),
  '@/components/management/forms/submissions/CreatePost': () =>
    import(`@/components/management/forms/submissions/CreatePost`),
  '@/components/management/forms/submissions/PostPreview': () =>
    import(`@/components/management/forms/submissions/PostPreview`),
  '@/components/management/forms/ownerGroups/List': () =>
    import(`@/components/management/forms/ownerGroups/List`),
  '@/components/management/forms/ownerGroups/Create': () =>
    import(`@/components/management/forms/ownerGroups/Create`),
  '@/components/management/forms/ownerGroups/Edit': () =>
    import(`@/components/management/forms/ownerGroups/Edit`),
  '@/components/management/forms/ownerGroups/Summary': () =>
    import(`@/components/management/forms/ownerGroups/Summary`),
  '@/components/management/forms/budgets/List': () =>
    import(`@/components/management/forms/budgets/List`),
  '@/components/management/forms/budgets/Create': () =>
    import(`@/components/management/forms/budgets/Create`),
  '@/components/management/forms/budgets/Summary': () =>
    import(`@/components/management/forms/budgets/Summary`),
  '@/components/management/forms/budgets/Edit': () =>
    import(`@/components/management/forms/budgets/Edit`),
  '@/components/management/forms/builder': () => import(`@/components/management/forms/builder`),
  '@/components/management/forms/forms/Edit': () =>
    import(`@/components/management/forms/forms/Edit`),
  '@/components/management/forms/forms/Summary': () =>
    import(`@/components/management/forms/forms/Summary`),
  '@/components/management/integrations/widgets': () =>
    import(`@/components/management/integrations/widgets`),
  '@/components/management/integrations/widgets/Ticker': () =>
    import(`@/components/management/integrations/widgets/Ticker`),
  '@/components/management/integrations/widgets/Causes': () =>
    import(`@/components/management/integrations/widgets/Causes`),
  '@/components/management/integrations/widgets/Testimonials': () =>
    import(`@/components/management/integrations/widgets/Testimonials`),
  '@/components/management/integrations/widgets/Organizations': () =>
    import(`@/components/management/integrations/widgets/Organizations`),
  '@/components/management/integrations/widgets/News': () =>
    import(`@/components/management/integrations/widgets/News`),
  '@/components/management/integrations/widgets/Events': () =>
    import(`@/components/management/integrations/widgets/Events`),
  '@/components/management/integrations/widgets/Positions': () =>
    import(`@/components/management/integrations/widgets/Positions`),
  '@/components/registration/BusinessVideo': () =>
    import(`@/components/registration/BusinessVideo`),
  '@/components/management/layout/Organization': () =>
    import(`@/components/management/layout/Organization`),
  '@/components/management/home/Organization': () =>
    import(`@/components/management/home/Organization`),
  '@/components/management/onboarding/organization': () =>
    import(`@/components/management/onboarding/organization`),
  '@/components/management/onboarding/organization/StepOverview': () =>
    import(`@/components/management/onboarding/organization/StepOverview`),
  '@/components/management/onboarding/organization/stepset/PageTemplate': () =>
    import(`@/components/management/onboarding/organization/stepset/PageTemplate`),
  '@/components/management/onboarding/organization/steps/RegisteredId': () =>
    import(`@/components/management/onboarding/organization/steps/RegisteredId`),
  '@/components/management/onboarding/organization/steps/Logo': () =>
    import(`@/components/management/onboarding/organization/steps/Logo`),
  '@/components/management/onboarding/organization/steps/AboutCombined': () =>
    import(`@/components/management/onboarding/organization/steps/AboutCombined`),
  '@/components/management/onboarding/organization/steps/AutoPostStory': () =>
    import(`@/components/management/onboarding/organization/steps/AutoPostStory`),
  '@/components/management/onboarding/organization/steps/AddConnection': () =>
    import(`@/components/management/onboarding/organization/steps/AddConnection`),
  '@/components/management/onboarding/organization/steps/Testimonials': () =>
    import(`@/components/management/onboarding/organization/steps/Testimonials`),
  '@/components/management/reports/organization/Volunteerism': () =>
    import(`@/components/management/reports/organization/Volunteerism`),
  '@/components/management/volunteers': () => import(`@/components/management/volunteers`),
  '@/components/management/volunteers/List': () =>
    import(`@/components/management/volunteers/List`),
  '@/components/management/volunteers/FindVolunteers': () =>
    import(`@/components/management/volunteers/FindVolunteers`),
  '@/components/management/approvalqueues/ApproveEndorsementRequests': () =>
    import(`@/components/management/approvalqueues/ApproveEndorsementRequests`),
  '@/components/management/invites/Contributors': () =>
    import(`@/components/management/invites/Contributors`),
  '@/components/management/volunteers/dashboard/OrganizationDashboard': () =>
    import(`@/components/management/volunteers/dashboard/OrganizationDashboard`),
  '@/components/management/volunteers/dashboard/Volunteers': () =>
    import(`@/components/management/volunteers/dashboard/Volunteers`),
  '@/components/management/relationships/organization/IndexBusinesses': () =>
    import(`@/components/management/relationships/organization/IndexBusinesses`),
  '@/components/management/relationships/organization/Testimonials': () =>
    import(`@/components/management/relationships/organization/Testimonials`),
  '@/components/management/relationships/organization/TestimonialRequests': () =>
    import(`@/components/management/relationships/organization/TestimonialRequests`),
  '@/components/management/relationships/organization/Businesses': () =>
    import(`@/components/management/relationships/organization/Businesses`),
  '@/components/management/relationships/organization/AddBusiness': () =>
    import(`@/components/management/relationships/organization/AddBusiness`),
  '@/components/management/relationships/organization/IndexOrganizations': () =>
    import(`@/components/management/relationships/organization/IndexOrganizations`),
  '@/components/management/relationships/organization/Organizations': () =>
    import(`@/components/management/relationships/organization/Organizations`),
  '@/components/management/relationships/organization/AddOrganization': () =>
    import(`@/components/management/relationships/organization/AddOrganization`),
  '@/components/management/relationships/Details': () =>
    import(`@/components/management/relationships/Details`),
  '@/components/management/profile/Organization': () =>
    import(`@/components/management/profile/Organization`),
  '@/components/management/reports/organization/Forms': () =>
    import(`@/components/management/reports/organization/Forms`),
  '@/components/management/integrations/widgets/Businesses': () =>
    import(`@/components/management/integrations/widgets/Businesses`),
  '@/components/management/integrations': () => import(`@/components/management/integrations`),
  '@/components/management/integrations/settings': () =>
    import(`@/components/management/integrations/settings`),
  '@/components/management/integrations/list': () =>
    import(`@/components/management/integrations/list`),
  '@/components/management/integrations/rss': () =>
    import(`@/components/management/integrations/rss`),
  '@/components/management/integrations/sso': () =>
    import(`@/components/management/integrations/sso`),
  '@/components/staff/StaffDiagnostics': () => import(`@/components/staff/StaffDiagnostics`),
  '@/components/management/activityfeed': () => import(`@/components/management/activityfeed`),
  '@/components/staff/promotion/Events': () => import(`@/components/staff/promotion/Events`),
  '@/components/staff/promotion/Positions': () => import(`@/components/staff/promotion/Positions`),
} as const;

export type RoutePath = keyof typeof components;
const routes: Record<RoutePath, any> = {};

// Start a timer
let start;
if (import.meta.env.SSR) {
  start = performance.now();
  console.log('Preloading route components on the server...');
}

// Preload all the routes on the server
if (import.meta.env.SSR) {
  for await (const [key, importer] of Object.entries(components)) {
    try {
      routes[key] = (await importer()).default;
    } catch (e) {
      console.error(`Error loading route component for ${key}:`, e);
      throw e;
    }
  }
} else {
  // Lazy load on the client
  for (const [key, importer] of Object.entries(components)) {
    routes[key] = lazy(importer);
  }
}

// End timer and log duration
if (import.meta.env.SSR) {
  const end = performance.now();
  console.log(`Route components loaded in ${end - start} ms`);
}

export default routes;
